import React from 'react'
import { Icon } from '@roo/roo'
import styles from './index.less'

export default (
  <Icon className={styles.loadingIcon} name="loading" size={32} color="#ffd100" />
)
